import { createSlice } from "@reduxjs/toolkit";

const testProdChangeSlice = createSlice({
  name: "testProdView",
  initialState: "test",
  reducers: {
    setChangeTestProd: (state, action) => {
      return action.payload;
    },
  },
});
export const { setChangeTestProd } = testProdChangeSlice.actions;
export default testProdChangeSlice.reducer;
